<template>
  <div>
    <div class="container">
      <!-- 预览图片 -->
      <div class="fileImg" v-for="(item, key) in imgArr" :key="key">
        <img class="fileUrl" :src="item" alt="" srcset="" />
        <div class="fileHover">
          <img @click="checkImg(item)" src="@/assets/images/check.png" alt="" srcset="" />
          &nbsp;
          <img @click="remove(item)" src="@/assets/images/sc.png" alt="" srcset="" />
        </div>
      </div>
      <!-- 点击添加图片框 -->
      <div class="addImages">
        <img class="addImagesBg" src="@/assets/images/images.png" alt="" srcset="" />
        <input id="FileInput" class="FileInput" type="file" @input="echo('input', $event.target.files[0])" />
      </div>
    </div>

    <div class="checkImg" v-if="value" @click="imgCloce()">
      <transition name="fade">
        <img :src="img" alt="" srcset="" />
      </transition>
    </div>
  </div>
</template>

<script>
import { uploadImg, url } from "@/api/index";
export default {
  props: ["imgArr"],
  data() {
    return {
      uploadUrl: "",
      FileInput: "",
      value: false,
      img: "",
      arr: [],
    };
  },
  methods: {
    echo(a, b) {
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      let param = new FormData(); // 创建form对象
      param.append("file", b); // 通过append向form对象添加数据
      uploadImg(param, config).then((res) => {
        if (res.code == 200) {
          this.$emit("addImg", res.data);
        } else {
          this.$Notice.error({
            title: res.data,
          });
        }
      });
    },
    remove(value) {
      this.imgArr.splice(this.imgArr.indexOf(value), 1);
    },
    checkImg(value) {
      this.img = value;
      this.value = true;
    },
    imgCloce() {
      this.value = false;
    },
  },
};
</script>

<style scoped>
.container {
  height: auto;
  display: flex;
  flex-direction: row;
}

.container>.addImages {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border: 1px #ccc dashed;
  border-radius: 6px;
  position: relative;
  cursor: pointer;
  margin-left: 10px;
}

.container>.addImages>.addImagesBg {
  position: relative;
  width: 60%;
  margin-top: 20%;
  margin-left: 20%;
  top: 0;
  cursor: pointer;
}

.container>.addImages>.FileInput {
  width: 100%;
  height: 100%;
  position: relative;
  top: calc(-100% - -5%);
  opacity: 0;
  background: red;
  cursor: pointer;
}

.container>.fileImg {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  box-shadow: #eee 0 0 3px 1px;
  margin-left: 10px;
  overflow: hidden;
}

.container>.fileImg:hover>.fileHover {
  opacity: 1;
}

.container>.fileImg>.fileUrl {
  width: 100%;
  height: 100%;
}

.container>.fileImg>.fileHover {
  transition: all 0.3s linear;
  opacity: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: relative;
  top: -65px;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.container>.fileImg>.fileHover>img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}





.checkImg {
  z-index: 99999;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.checkImg>img {
  height: 90%;
}

.fade-enter-from {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.3s;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-active {
  transition: all 0.3s;
}

.fade-leave-to {
  opacity: 0;
}
</style>
